import {
  ButtonPrimary,
  ButtonPseudo,
  IconBlock,
  IconSelected,
  Popup,
} from '@ui/src';
import { AccountCurrenciesPopupTypes } from './types';

import cn from './styles.module.css';

const AccountCurrenciesPopup = ({
  currenciesList,
  selectedBlockCurrency,
  setBlockPopupVisible,
  setSelectedBlockCurrency,
  setError,
  blockPopupVisible,
  error,
  disableInProgress,
  onDisableBalanceAction,
  selectedEnableCurrency,
  setEnablePopupVisible,
  setSelectedEnableCurrency,
  enablePopupVisible,
  enableInProgress,
  onEnableBalanceAction,
}: AccountCurrenciesPopupTypes) => (
  <>
    <Popup
      title={`Disable the balance in ${
        currenciesList?.find((item) => item.id === selectedBlockCurrency?.id)
          ?.name
      } for the customer?`}
      onCancelClick={() => {
        setBlockPopupVisible(false);
        setSelectedBlockCurrency(undefined);
        setError('');
      }}
      isVisible={blockPopupVisible}
    >
      <>
        {error && <div className={cn.error}>{error}</div>}
        <div className={cn.controls}>
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setBlockPopupVisible(false);
              setSelectedBlockCurrency(undefined);
              setError('');
            }}
            className={cn.closeButton}
            bold
          />
          <ButtonPrimary
            text={disableInProgress ? 'Loading...' : 'Disable'}
            icon={<IconBlock className={cn.okButtonBlock} />}
            onClick={onDisableBalanceAction}
            className={cn.okButton}
            bold
          />
        </div>
      </>
    </Popup>
    <Popup
      title={`Enable the balance in ${
        currenciesList?.find((item) => item.id === selectedEnableCurrency?.id)
          ?.name
      } for the customer?`}
      onCancelClick={() => {
        setEnablePopupVisible(false);
        setSelectedEnableCurrency(undefined);
        setError('');
      }}
      isVisible={enablePopupVisible}
    >
      <>
        {error && <div className={cn.error}>{error}</div>}
        <div className={cn.controls}>
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setEnablePopupVisible(false);
              setSelectedEnableCurrency(undefined);
              setError('');
            }}
            className={cn.closeButton}
            bold
          />
          <ButtonPrimary
            text={enableInProgress ? 'Loading...' : 'Enable'}
            icon={<IconSelected width={18} height={18} />}
            onClick={onEnableBalanceAction}
            disabled={enableInProgress}
            className={cn.okButton}
            bold
          />
        </div>
      </>
    </Popup>
  </>
);

export default AccountCurrenciesPopup;
